/* PATOYS: recently viewed products (localStorage) for the homepage "Continue shopping" and "Recommended for you" rows. No dependencies. */
(function () {
  if (window.__ptRecentInit) return;
  window.__ptRecentInit = true;
  var KEY = 'pt_recent_v1', MAX = 8;
  function read() {
    try { var a = JSON.parse(localStorage.getItem(KEY) || '[]'); return Array.isArray(a) ? a : []; } catch (e) { return []; }
  }
  function write(a) { try { localStorage.setItem(KEY, JSON.stringify(a.slice(0, MAX))); } catch (e) {} }

  var track = document.getElementById('pt-recent-track');
  if (track) {
    try {
      var d = JSON.parse(track.textContent);
      if (d && d.id && d.u) write([d].concat(read().filter(function (x) { return x && x.id !== d.id; })));
    } catch (e) {}
  }

  var items = read().filter(function (x) { return x && typeof x.u === 'string' && x.u.charAt(0) === '/' && x.t; });

  var box = document.querySelector('[data-pt-recent]');
  if (box && items.length) {
    var list = box.querySelector('[data-pt-recent-list]');
    items.forEach(function (x) {
      var li = document.createElement('li');
      var card = document.createElement('div'); card.className = 'pt-card';
      var am = document.createElement('a'); am.className = 'pt-card__media'; am.href = x.u; am.tabIndex = -1; am.setAttribute('aria-hidden', 'true');
      if (typeof x.i === 'string' && x.i.indexOf('https://') === 0) {
        var img = document.createElement('img'); img.src = x.i; img.alt = ''; img.loading = 'lazy'; img.width = 400; img.height = 400; am.appendChild(img);
      }
      var body = document.createElement('div'); body.className = 'pt-card__body';
      var t = document.createElement('a'); t.className = 'pt-card__title'; t.href = x.u; t.textContent = x.t;
      var p = document.createElement('p'); p.className = 'pt-card__price'; p.textContent = x.p || '';
      body.appendChild(t); body.appendChild(p); card.appendChild(am); card.appendChild(body); li.appendChild(card); list.appendChild(li);
    });
    box.hidden = false;
  }

  var recs = document.querySelector('[data-pt-recs]');
  if (recs && items.length) {
    var load = function () {
      var url = recs.getAttribute('data-url') + '?section_id=' + encodeURIComponent(recs.getAttribute('data-section-id')) + '&product_id=' + encodeURIComponent(items[0].id) + '&limit=8&intent=related';
      fetch(url).then(function (r) { return r.ok ? r.text() : ''; }).then(function (html) {
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var inner = doc.querySelector('[data-pt-recs-inner]');
        if (inner && inner.querySelector('li')) {
          recs.querySelector('[data-pt-recs-body]').innerHTML = inner.innerHTML;
          recs.hidden = false;
        }
      }).catch(function () {});
    };
    if (document.readyState === 'complete') setTimeout(load, 300);
    else window.addEventListener('load', function () { setTimeout(load, 300); });
  }
})();
